import React, { useState, useEffect } from "react";
import { FiX } from "react-icons/fi";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Logo from "../../../assets/logoweb.jpg";
import api from "../../../utils/api";
import Cookies from 'js-cookie'
import GoogleMapsTracking from "../Summary/maps.jsx";
import OtpPopup from "./OtpPopup";
import LocationSelector from "../Summary/JustMap.jsx";
import { toast } from "react-toastify";
import { showCustomAlert } from "./Toast";
const CustomPopup = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [address, setAddress] = useState("")
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    contact: "",
    address : "",
    deviceToken: "device_token_ali121", // Static value
    isActive: true, // Static value
    isBlock: false, // Static value
  });

  // Handle form input changes
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  // Handle phone input change
  const handlePhoneChange = (value) => {
    // Ensure the value starts with a "+" symbol
    const formattedValue = value.startsWith("+") ? value : `+${value}`;
    setFormData({ ...formData, contact: formattedValue });
  };
  
  useEffect(() => {
   
    if (address) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        address: address,
      }));
    }
  }, [address]);
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("🚀 ~ handleSubmit ~ formData:", formData);

    try {
      const response = await api.post("/auth/register", formData);
      console.log("Response:", response.data);
const saveReward = Cookies.set('reward' , response?.data?.reward)
console.log( 'reward' , response?.data?.reward)
      localStorage.setItem("email", response.data.user.email);
  showCustomAlert({
          title: 'Otp sent',
          html: '<p style="color: #555;">OTP sent to your email. Please verify your account."</p>',
          icon: 'success',
          confirmButtonText: 'Continue',
          confirmButtonColor: '#af313d',
          background: '#ffffff',
        });
        Cookies.remove("isPopupShown");
      setIsOpen(false);
      setShowOtpPopup(true);
    } catch (error) {
      console.error("Error:", error.response?.data);
      showCustomAlert({
        title: 'Error',
        html: `<p style="color: #555;">${error.response?.data?.message}"</p>`,
        icon: 'error',
        confirmButtonText: 'ok',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
        timer: null
      });
      
    }
  };

  return (
    <div className="">
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[90%] md:w-[80%] mx-auto lg:w-[50%] rounded-lg shadow-lg relative">
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-3 right-6 bg-black rounded-full w-10 h-10 items-center justify-center flex text-xl text-white font-bold hover:text-gray-700"
            >
              <FiX />
            </button>

            <div className="p-8 max-h-[90vh] overflow-y-scroll md:px-16 custom-scrollbar">
              {/* <div className="flex items-center justify-center gap-2">
                <img src={Logo} alt="" className=" lg:h-[90px]" />
              
              </div> */}
              <h2 className="text-center font-baloo lg:text-[28px] font-[700] mb-2 ">
                Create your account
              </h2>
              <p className="text-center text-[10.07px] sm:text-[10.07px] md:text-[12px] lg:text-[13px] text-gray-500 mb-3">
                Welcome! Please create an account for you.
              </p>

              {/* Form */}
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label
                    htmlFor="name"
                    className="block text-[14px] font-medium text-black font-baloo mb-2"
                  >
                    Name
                  </label>
                  <input
                    id="name"
                    type="text"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Username"
                    className="w-full p-3 border border-gray-300 rounded-md"
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="email"
                    className="block text-[14px] font-medium text-black font-baloo mb-2"
                  >
                    Email Address
                  </label>
                  <input
                    id="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email address"
                    className="w-full p-3 border border-gray-300 rounded-md"
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="contact"
                    className="block text-[14px] font-medium text-black font-baloo mb-2"
                  >
                    Mobile Number
                  </label>
                  <PhoneInput
                     country={"gb"}
                     onlyCountries={["gb"]}
                    value={formData.contact}
                    onChange={handlePhoneChange}
                    inputClass="w-full p-3 border border-gray-300 rounded-md h-16 custom-phone-input" // Add your custom class here
                  />
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="address"
                    className="block text-[14px] font-medium text-black font-baloo mb-2"
                  >
                     Address
                  </label>
                  <LocationSelector
                  divStyles=" "
                  inputStyles="w-full p-3 border border-gray-300 rounded-md"
                  showButton = {false}
                   onAddressSelect={(address) => setAddress(address)} />
                 
                </div>
                <div className="mb-4">
                  <label
                    htmlFor="password"
                    className="block text-[14px] font-medium text-black font-baloo mb-2"
                  >
                    Password
                  </label>
                  <input
                    id="password"
                    type="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    className="w-full p-3 border border-gray-300 rounded-md"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full rounded-full md:tracking-[2px] tracking-[1px] sm:tracking-[1px] bg-[#AF313D] text-white p-3 mb-4 text-[14.39px] sm:text-[14.39px] md:text-[] lg:text-[20px] font-baloo font-semibold"
                >
                  Create Account
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Render OTP popup */}
      {showOtpPopup && <OtpPopup />}
    </div>
  );
};

export default CustomPopup;
